/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import useSalesforceProductRecommendationQuery from '../../../../../../helpers/Personalization/useSalesforceProductRecommendationQuery';
import { bool, string } from 'prop-types';
import { ProductCard } from './ProductCard';
import useClickStreamCustomEventsTracking from '../../../../../../helpers/Personalization/useClickstreamCustomEventsTracking';
import mbpLogger from 'mbp-logger';

export const RecommendedProduct = ({ campaignFeature, partNumber, productName, mobile, title, isFloraVerse, occasion}) => {
    const { loading, error, data, variables } = useSalesforceProductRecommendationQuery({
        queryName: 'PDPProductRecommendations',
        currentBrand: '1800flowers',
        campaignFeature,
        partNumber,
        productName,
        occasion,
        targeting: {
            pageType: 'product',
        },
    });

    const trackClickThrough = useClickStreamCustomEventsTracking({
        salesforceResponse: data?.productRecommendationsSF,
        isFireImpression: true,
        page: { type: 'product' },
    });

    const products = data?.productRecommendationsSF?.products || [];
    const topProduct = products?.[0] || {};

    const handleProductClick = () => {
        trackClickThrough(topProduct?.partNumber);
    };

    const responsiveImagePath = (name, path) => {
        if (!name || !path) return '';
        const extension = (name || '').includes('_gif') ? '.gif' : 'x.jpg';
        return `${path + name + extension}`;
    };

    if (loading || variables?.skip) {
        return <ProductCard mobile={mobile} loading={loading} isFloraVerse={isFloraVerse}/>;
    }

    if (error || !products.length) {
        mbpLogger.logError({
            appName: process.env.npm_package_name,
            component: 'RecommendedProduct.js',
            message: `MomVerse ~ Error loading products from campaign: (${campaignFeature})`,
            error,
        });
        return null;
    }

    // Get the first product & craft image src
    const imageSrc = responsiveImagePath(topProduct?.image?.name, topProduct?.image?.path);

    // Gather sale price range if present else resort to retail.
    const { sale = [], retail = [] } = topProduct?.skuPriceRange || {};
    const prices = sale.length ? sale : retail;
    const priceRange = Array.from(new Set([prices?.[0]?.value || 0, prices?.[prices.length - 1]?.value || 0]));

    return (
        <ProductCard
            mobile={mobile}
            title={title}
            productName={topProduct.name}
            imageSrc={imageSrc}
            pdpLink={topProduct?.seo?.url}
            priceRange={priceRange}
            handleProductClick={handleProductClick}
            isFloraVerse={isFloraVerse}
        />
    );
};

RecommendedProduct.defaultProps = {
    partNumber: null,
    productName: null,
    isFloraVerse: false,
};

RecommendedProduct.propTypes = {
    mobile: bool.isRequired,
    campaignFeature: string.isRequired,
    title: string.isRequired,
    partNumber: string,
    productName: string,
    isFloraVerse: bool,
    occasion: string,
};
